/**
 * 特殊リードタイムの Directus フィルタ。順に見て最初のヒットを使う。
 * town がある: eq → _null → 発着入替 eq → 入替 _null
 * town が空: town 条件なし → _null → 入替なし → 入替 _null
 */
export type SpecialLeadTimeLookup = {
  fromPrefCode: string
  toPrefCode: string
  toCity: string
  toTown?: string | null
}

const cityFilter = (
  fromPrefCode: string,
  toPrefCode: string,
  toCity: string,
  townMode: 'omit' | 'eq' | 'null',
  town?: string | null,
) => {
  const filter: Record<string, unknown> = {
    fromPrefCode: { _eq: fromPrefCode },
    toPrefCode: { _eq: toPrefCode },
    toCity: { _eq: toCity },
  }
  if (townMode === 'eq' && town) {
    filter.toTown = { _eq: town }
  }
  if (townMode === 'null') {
    filter.toTown = { _null: true }
  }
  return filter
}

export const specialLeadTimeFilters = (
  forward: SpecialLeadTimeLookup,
  swapped?: SpecialLeadTimeLookup | null,
): any[] => {
  const filters: any[] = []
  const pushSide = (side: SpecialLeadTimeLookup) => {
    const town = (side.toTown || '').trim()
    if (town) {
      filters.push(
        cityFilter(side.fromPrefCode, side.toPrefCode, side.toCity, 'eq', town),
      )
      filters.push(
        cityFilter(side.fromPrefCode, side.toPrefCode, side.toCity, 'null'),
      )
    } else {
      filters.push(
        cityFilter(side.fromPrefCode, side.toPrefCode, side.toCity, 'omit'),
      )
      filters.push(
        cityFilter(side.fromPrefCode, side.toPrefCode, side.toCity, 'null'),
      )
    }
  }
  pushSide(forward)
  if (swapped) pushSide(swapped)
  return filters
}
